var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * GridFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconGridFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41526 1.10516C2.13906 1.10516 1.10449 2.13973 1.10449 3.41593V8.09824C1.10449 9.37444 2.13906 10.409 3.41526 10.409H8.09757C9.37377 10.409 10.4083 9.37444 10.4083 8.09824V3.41593C10.4083 2.13973 9.37377 1.10516 8.09757 1.10516H3.41526ZM15.9013 1.10516C14.6251 1.10516 13.5906 2.13973 13.5906 3.41593V8.09824C13.5906 9.37444 14.6251 10.409 15.9013 10.409H20.5837C21.8599 10.409 22.8944 9.37444 22.8944 8.09824V3.41593C22.8944 2.13973 21.8599 1.10516 20.5837 1.10516H15.9013ZM3.41526 13.5915C2.13906 13.5915 1.10449 14.6261 1.10449 15.9023V20.5846C1.10449 21.8608 2.13906 22.8953 3.41526 22.8953H8.09757C9.37377 22.8953 10.4083 21.8608 10.4083 20.5846V15.9023C10.4083 14.6261 9.37377 13.5915 8.09757 13.5915H3.41526ZM15.9013 13.5915C14.6251 13.5915 13.5906 14.6261 13.5906 15.9023V20.5846C13.5906 21.8608 14.6251 22.8953 15.9013 22.8953H20.5837C21.8599 22.8953 22.8944 21.8608 22.8944 20.5846V15.9023C22.8944 14.6261 21.8599 13.5915 20.5837 13.5915H15.9013Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconGridFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconGridFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconGridFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-grid-filled') === undefined) {
    customElements.define('cat-icon-grid-filled', BlocksIconGridFilled);
}
